import { render } from "./product-swatches.vue?vue&type=template&id=069681dd"
import script from "./product-swatches.vue?vue&type=script&lang=js"
export * from "./product-swatches.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__